; namespace Gordic.Vyp.Dlg
{
    const { gcontent } = Decorators

    @gcontent
    export class EditaceZasilkyDlg extends GContentBase
    {
        model: Wfl.Interface.GEditaceZasilkyDto;
        validators: any;

        onContentReady()
        {
            const form = new Gordic.Forms.Form({ name: "FormZasEdit", layoutDescriptor: "L1M1S1" });
            form.addSection();
            form.addPrefab(Wfl.Prefabs.GIdentifikatorDokumnetuSpisu({ fieldOpt: { model: "model.ixp = value", disabled: true } }));
            form.addRow("jres:23900044").addField("gstringbox", "w-3", { name: "pod_cislo", model: "model.pod_cislo = value"}); //RC 23900044 : Podací číslo
            form.addRow("jres:23900015").addField("gnumberbox", "w-3", { name: "poplatek", model: "model.poplatek = value", decimals: 2, minValue: 0, maxValue: 999.99 });
            form.addRow("jres:23900016").addField("gnumberbox", "w-3", { name: "vaha", model: "model.vaha = value", decimals: 4, minValue: 0, maxValue: 99.9999 });                 //RC 23900016 : Váha
            form.addRow("jres:23900017").addField("gnumberbox", "w-3", { name: "cena", model: "model.cena = value", decimals: 2, minValue: 0, maxValue: 1099.99 });                 //RC 23900017 : Cena

            this.defaultForm = $("<div>").appendTo(this.element).gform("createFrom", form);
            this.findFields().gfield("model", "apply", this.model).gfield("model", "validators", this.validators);
        }

        OKClick()
        {
            if (this.defaultForm)
            {
                if (!this.defaultForm.gform("isValid")) return;
                this.findFields().gfield("model", "collect", this.model);
                this.close(this.model);   
            }       
        }
    }
}